import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'folder'
})
export class FolderPipe implements PipeTransform {

  transform(tests: any, folderId: string | null): any[] {
    // if (!folderId){
    //   return tests;
    // }
    let response = []
    if (!folderId || folderId == '') {
      response = tests.filter(test => !test.path || test.path === '');
      return response;
    }
    
    if (tests && tests.length > 0) {
      for (let i = 0; i < tests.length; i++) {
        if (tests[i].path === folderId) {
          response.push(tests[i]);
        }
      }
    }
    return response;
  }

}
